import React from "react";
import "./PortfolioPage.css";

const PortfolioPage = () => {
  return (
    <div>
      <div className="hero_img port_mobile_img">
        <img src="/assets/portfolio/heroimg.jpg" alt="" />
        {/* <img
          src="https://www.crestdigitel.com/wp-content/uploads/2022/10/portfolio_banner-1.jpg"
          alt=""
        /> */}
        <div className="hero_title">An overview of our portfolio</div>
      </div>
      <div className="container2">
        <div className="portp_div1 container">
          <h2 id="port1">
            As the leading passive connectivity infrastructure provider, we
            offer a wide range of services for commercial, residential, and
            industrial customers.
          </h2>
        </div>

        <div className="portp_div2 container">
          <div className="portp_div21  ">
            <h2>In-Building Solution (IBS)</h2>
            <p>
              We deploy IBS on behalf of the Mobile Service Providers, which
              aims to expand mobile network coverage and capacity in
              hard-to-access areas, in hospitals, hotels, malls, metros and
              airports, where accessing mobile networks is challenging. The
              deployed IBS is also capable of being integrated with our outdoor
              poles or rooftop poles solutions resulting in better coverage.
              This State-of-the-Art In-Building Solution (IBS) provides mobile
              operators with the ability to extend and distribute their cellular
              signal in and around buildings in areas where outdoor tower
              signals are inadequate or non-existent. By implementing our
              plug-and-play design architecture for the Mobile Service
              Providers, we deliver solutions independent of technologies,
              enabling us to work on behalf of all operators efficiently and
              effectively. As a part of our 5G ready IBS design, we are ready to
              provide a seamless user experience to our customers’ clients. IBS
              is installed in metro stations, tunnels, tunnelling
              infrastructure, offices, malls, hospitals, airports, and countless
              other locations.
            </p>
          </div>
          <div className="portp_div31" id="port2">
            <img src="/assets/portfolio/portfolioimg1.jpg" alt="" />
          </div>
        </div>

        <div className="portp_div2 container port_flex">
          <div className="portp_div31">
            <img src="/assets/portfolio/portfolioimg2.jpg" alt="" />
          </div>
          <div className="portp_div21  ">
            <h2>Small Cell Solution (SC)</h2>
            <p className="no_width" id="port3">
              Small Cell Solution offers rooftop poles and street furniture to
              accommodate small cellular base stations to improve network
              coverage in densely populated areas and increase the network’s
              capacity.
            </p>
          </div>
        </div>

        <div className="portp_div2 container">
          <div className="portp_div21  ">
            <h2>ResNet Solution</h2>
            <p>
              ResNet solution aims to provide high-speed internet connection to
              residential complexes so that residents can access high-quality
              Internet service. The floors of the building are interconnected in
              a uniform and seamless manner across the entire structure.
            </p>
          </div>
          <div className="portp_div31" id="port4">
            <img src="/assets/portfolio/portfolioimg3.jpg" alt="" />
          </div>
        </div>

        <div className="portp_div2 container port_flex">
          <div className="portp_div31">
            <img src="/assets/portfolio/portfolioimg4.jpg" alt="" />
          </div>
          <div className="portp_div21  ">
            <h2>BizNet Solution</h2>
            <p className="no_width">
              BizNet aims to provide industrial premises with high-speed data
              and voice communication for business and commercial purposes,
              enabling them to communicate better.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PortfolioPage;
